import { FC } from 'react';
import style from './carAssetValueTipsStyle.module.css';
import tipCleaning from '@/assets/images/tipCleaning.png';
import tipDriving from '@/assets/images/tipDriving.png';
import tipMaintenance from '@/assets/images/tipMaintenance.png';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';

export const CarAssetValueTipsPage: FC = () => {
  return (
    <PageTemplate
      pageName="car-asset-value-tips"
      title="乗り方で価値が変わる。"
      showNavBack
    >
      <div className={style['container']}>
        <div className={style['card']}>
          {/* イントロ */}
          <p className={style['intro']}>
            走り方・整備・点検の積み重ねが、
            <br />
            &ldquo;将来の車の価値&rdquo;になります。
          </p>

          {/* セクション1: 整備の価値 */}
          <div className={style['section']}>
            <h3 className={style['heading']}>
              ちゃんと整備してきたのに、
              <br />
              その価値が伝わらない
              <br />
              と思ったことはありませんか？
            </h3>
            <p className={style['body']}>
              価値は「数字」だけでは決まりません。
              <br />
              年式や走行距離だけでなく、どんなケアをしてきたかが、車の評価を左右します。
              <br />
              整備履歴や点検データは、車が大切に扱われてきた証拠です。
            </p>
          </div>

          {/* セクション2: データ */}
          <div className={style['section']}>
            <h3 className={style['heading']}>データがあると、評価が変わる</h3>
            <ul className={style['bullet-list']}>
              <li>査定時の確認がスムーズ</li>
              <li>不安要素が減り、評価が安定</li>
              <li>結果として、価値に反映されやすい</li>
            </ul>
            <p className={style['link-text']}>行動の記録が、価値を支えます。</p>
          </div>

          {/* セクション3: 日々の積み重ね */}
          <div className={style['section-last']}>
            <h3 className={style['heading']}>価値は、日々の積み重ね</h3>
            <p className={style['body-center']}>
              いまの行動が、
              <br />
              次につながる車の価値になります。
            </p>

            <div className={style['tips-list']}>
              <div className={style['tip-card']}>
                <img
                  src={tipDriving}
                  className={style['tip-icon']}
                  alt="丁寧な運転"
                />
                <h4 className={style['tip-title']}>丁寧な運転を心がける</h4>
                <p className={style['tip-badge']}>資産価値が最大◯％アップ</p>
                <p className={style['tip-body']}>
                  「ふんわりアクセル」「早めのブレーキ」を意識することで、
                  タイヤやブレーキの摩耗を抑え、足回り部品の寿命を延ばします。
                  急加速・急ブレーキを避けた運転は車への負担を減らし、
                  エンジンや駆動系のコンディションも安定。
                  走り方の積み重ねが、将来の評価につながります。
                </p>
              </div>

              <div className={style['tip-card']}>
                <img
                  src={tipCleaning}
                  className={style['tip-icon']}
                  alt="清潔に保つ"
                />
                <h4 className={style['tip-title']}>外装・内装を清潔に保つ</h4>
                <p className={style['tip-badge']}>評価額が最大◯％アップ</p>
                <p className={style['tip-body']}>
                  定期的な洗車や車内清掃は、見た目をきれいに保つだけでなく、
                  キズ・サビ・内装劣化などの早期発見にもつながります。
                  シートの擦れやニオイの蓄積を防ぐことで、
                  「大切に使われてきた車」という印象を保ちやすくなります。
                </p>
              </div>

              <div className={style['tip-card']}>
                <img
                  src={tipMaintenance}
                  className={style['tip-icon']}
                  alt="点検活用"
                />
                <h4 className={style['tip-title']}>
                  保証・点検をきちんと活用する
                </h4>
                <p className={style['tip-badge']}>安心評価が最大◯％アップ</p>
                <p className={style['tip-body']}>
                  定期点検や保証を適切に利用している車は、
                  故障リスクが低く、修理履歴も明確。
                  「トラブルを未然に防いできた」という事実そのものが、
                  次に乗る人への安心感となり、車の価値を支えます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};
